import React, { useEffect, useState } from 'react'
import Button from '../../../../component/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { Toast } from '../../../../service/toast';
import RewardsList from './RewardsList';
import CustomerInformation from './CustomerInfromation';
import RedeemResponseModal from '../../../../modalComponents/RedeemResponseModal';
import AdminComment from './AdminComments';

const RedeemRewardDetails = (props) => {

    const { } = props
    const [sendResponsePopUp, setSendResponsePopUp] = useState(false)
    const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
    const [redeemData, setRedeemData] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const pathName = location?.search?.split('?id=')
    const params = pathName[1]


    const redirectBack = () => {
        navigate('/admin/redeemRewards')
    }

    const handleSendResponse = () => {
        setSendResponsePopUp(false)
        setShowSuccessPopUp(true)
        navigate('/admin/redeemRewards')
    }

    const specificProduct = async (id) => {
        await request({
            url: `${Exported.Endpoints.redeemRewardsItem}?redeem_id=${id}`,
            method: Exported.APIMethods.GET
        }).then((res) => {
            const obj = {
                result: res?.data?.data
            }
            setRedeemData([res?.data?.data]);
            console.log(res.data.data, "res")

        }).catch((err) => {
            console.log(err, "err");
        })
    }

    const onSubmit = (data) => {
        const requestData = {
            message: data.message
        }
        request({
            url: `${Exported.Endpoints.redeemReply}?redeem_id=${params}`,
            method: Exported.APIMethods.POST,
            data: requestData
        }).then((res) => {
            console.log(res, "mail")
            if (res?.data?.status) {
                handleSendResponse()
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    };



    useEffect(() => {
        if (location?.pathname) {
            specificProduct(params)
        }
    }, [])
    
    const bulkTitles = redeemData?.map((it) => it?.reward_details?.map((item) => item?.title)).flat().join(", ")

    return (
        <>

            <div className={``}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title flex justify-between w-[100%]`}>
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                            <div>Redeem Details</div>
                        </div>
                        
                        {/* {redeemData?.map((item) =>(
                           item?.status === 1 && <Button text={"Send a Response"} className={``} smallBtn onClick={() => setSendResponsePopUp(true)} />
                        ))} */}
                    </div>
                </div>
                {
                    redeemData?.map((item, index) => (
                        <div className='my-8'>
                            <RewardsList  redeemDetails={item?.reward_details?.map((reward) => reward) } />
                            <CustomerInformation name={`${item?.user_details?.firstName} ${item?.user_details?.lastName}`} email={item?.user_details?.email} mobile={item?.user_details?.mobileNumber} address={item?.delivery_address} />
                            <AdminComment comment={item?.internal_notes || "-"} response={item?.reply_to_user || "-"} />
                        </div>
                    ))
                }
            </div>
            {
                sendResponsePopUp ?
                    <RedeemResponseModal isOpen={sendResponsePopUp} closePopUp={setSendResponsePopUp} handleSuccess={handleSendResponse} onSubmit={onSubmit} value={redeemData?.map((it) => it?.user_details?.email)} titleValue={bulkTitles}
                    />
                    : null
            }

        </>
    )
}

export default RedeemRewardDetails